// Libs
import classNames from 'classnames/bind';
import { Button, Grid2, Stack, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseTextEditor } from '~/components/common';
// Others
import { ModeTextEditorEnum, TypeTabCreateEstimateEnum } from '~/utils/enum/common';
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormEstimate } from '~/utils/interface/estimate';
// Styles, images, icons
import styles from './CreateEstimatePrivateNotesTab.module.scss';

type Props = {
  onEdit?: (data: IFormEstimate, type: string) => void;
  onCancelEdit: () => void;
};

const cx = classNames.bind(styles);

const CreateEstimatePrivateNotesTab = (props: Props) => {
  //#region Destructuring Props
  const { onEdit, onCancelEdit } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/estimate']);
  const { id: estimateId } = useParams();
  const {
    control,
    getValues,
    formState: { errors, isDirty },
  } = useFormContext<IFormEstimate>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleSubmitFormPrivateNotes = () => {
    const dataForm = getValues();
    const dataBody: IFormEstimate = {
      clientId: EMPTY_STRING,
      notes: dataForm?.notes || EMPTY_STRING,
      privateNotesId: dataForm?.privateNotesId || EMPTY_STRING,
    };

    onEdit && onEdit(dataBody, TypeTabCreateEstimateEnum.PRIVATE_NOTES);
  };
  //#endregion Handle Function

  return (
    <Grid2
      component='div'
      id='privateNotesComponent'
      className={cx('container')}
      container
      rowSpacing={'12px'}
    >
      <Grid2 size={'grow'} container>
        <Grid2 size={12}>
          <Typography color='primary' className={cx('title')}>
            {t('private_notes_title')}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Controller
            name={`notes`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <BaseTextEditor
                mode={ModeTextEditorEnum.CREATE}
                height={269}
                value={value}
                onChange={(textEditor: string) => onChange(textEditor)}
                errorMessage={errors.notes?.message}
              />
            )}
          />
        </Grid2>
        {estimateId && (
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            component={'div'}
            spacing={'12px'}
            className={cx('formFooter')}
          >
            <Button variant='outlined' onClick={onCancelEdit}>
              {t('common_action_cancel', { ns: 'common/base' })}
            </Button>

            <Button
              variant='contained'
              type='button'
              onClick={handleSubmitFormPrivateNotes}
              disabled={!isDirty}
            >
              {t('common_action_save', { ns: 'common/base' })}
            </Button>
          </Stack>
        )}
      </Grid2>
    </Grid2>
  );
};

export default CreateEstimatePrivateNotesTab;
